import { WebView } from '@/components/common/Layout'
import { useTranslation } from '@/i18n/configs'
import { NextPageWithLayout } from '@/pages/_app.page'

import { ServiceTerms } from './ServiceTerms'

const ServiceTermsRoute: NextPageWithLayout = () => {
  const t = useTranslation()
  const title = t('rules.service_terms', { defaultValue: '' })

  return (
    <WebView title={title}>
      <ServiceTerms />
    </WebView>
  )
}

export default ServiceTermsRoute
